import {useQuery} from "@tanstack/react-query";

import {ParamsOptions} from "@/src/modules/core/types";

import {propertiesService} from "../services";

const ADD_ALL_LIMIT = 500;

export function useAllProperties(options: ParamsOptions = {sort: "name"}) {
  const query = useQuery({
    queryKey: ["all-properties", options],
    queryFn: () =>
      propertiesService.getProperties({
        ...options,
        page: {limit: ADD_ALL_LIMIT, offset: 0},
      }),
    enabled: false,
  });

  return {
    properties: query.data?.data ?? [],
    refetch: query.refetch,
    isFetching: query.isFetching,
  };
}
